export function initCardTracks() {
    const tracks = [
        {
            viewport: ".customer-trust-section__viewport",
            track: ".customer-trust-section__track",
            group: ".customer-trust-section__group",
            duration: "--customer-trust-scroll-duration",
        },
        {
            viewport: ".media-spotlight-section__viewport",
            track: ".media-spotlight-section__card-list",
            group: ".media-spotlight-section__group",
            duration: "--media-scroll-duration",
            pauseOnFocus: true,
        },
        {
            viewport: ".save-up__viewport",
            track: ".save-up__list",
            group: ".save-up__group",
            duration: "--save-up-scroll-duration",
            pauseOnFocus: true,
        },
    ];
    tracks.forEach(initTrack);
}

function initTrack(config) {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const hoverMedia = window.matchMedia("(any-hover: hover)");

    document.querySelectorAll(config.viewport).forEach((viewport) => {
        const track = viewport.querySelector(config.track);
        const group = track?.querySelector(config.group);
        if (!group || track.classList.contains("card-track--controlled")) return;

        let distance = 0;
        let duration = 32000;
        let direction = -1;
        let position = 0;
        let speed = 1;
        let targetSpeed = 1;
        let frame = null;
        let previousTime = null;
        let isVisible = true;
        let isEnabled = true;

        const render = () => {
            track.style.transform = `translate3d(${direction * position}px, 0, 0)`;
        };

        const tick = (time) => {
            if (previousTime !== null && distance > 0) {
                const elapsed = time - previousTime;
                // Integrate the easing so changing speed never changes the current position.
                const easing = Math.exp(-elapsed / 120);
                const travel = targetSpeed * elapsed + (speed - targetSpeed) * 120 * (1 - easing);
                speed = targetSpeed + (speed - targetSpeed) * easing;
                position = (position + distance / duration * travel) % distance;
                render();
            }
            previousTime = time;
            frame = requestAnimationFrame(tick);
        };

        const syncPlayback = () => {
            if (frame !== null) cancelAnimationFrame(frame);
            frame = null;
            previousTime = null;

            if (reducedMotion.matches || !isEnabled) {
                position = 0;
                render();
            } else if (isVisible && !document.hidden
                && !(config.pauseOnFocus && viewport.contains(document.activeElement))) {
                frame = requestAnimationFrame(tick);
            }
        };

        const measure = () => {
            const style = getComputedStyle(track);
            distance = group.getBoundingClientRect().width;
            duration = parseFloat(style.getPropertyValue(config.duration)) * 1000 || 32000;
            direction = style.direction === "rtl" ? 1 : -1;
            isEnabled = style.getPropertyValue("--card-track-enabled").trim() !== "0";
            position = distance ? position % distance : 0;
            render();
            syncPlayback();
        };

        const updateHover = () => {
            targetSpeed = hoverMedia.matches && viewport.matches(":hover") ? 1 / 3 : 1;
        };

        // Keep the CSS fallback's visible position when JS takes control.
        const transform = getComputedStyle(track).transform;
        if (transform !== "none") position = Math.abs(new DOMMatrixReadOnly(transform).m41);
        track.classList.add("card-track--controlled");
        measure();
        updateHover();
        speed = targetSpeed;

        viewport.addEventListener("pointerenter", (event) => {
            if (event.pointerType !== "touch") updateHover();
        });
        viewport.addEventListener("pointerleave", () => { targetSpeed = 1; });
        viewport.addEventListener("pointercancel", () => { targetSpeed = 1; });
        if (config.pauseOnFocus) {
            viewport.addEventListener("focusin", syncPlayback);
            viewport.addEventListener("focusout", () => { queueMicrotask(syncPlayback); });
        }
        hoverMedia.addEventListener("change", updateHover);
        reducedMotion.addEventListener("change", syncPlayback);
        document.addEventListener("visibilitychange", syncPlayback);
        window.addEventListener("resize", measure);
        new ResizeObserver(measure).observe(group);
        new IntersectionObserver((entries) => {
            isVisible = entries[0].isIntersecting;
            syncPlayback();
        }).observe(viewport);
        syncPlayback();
    });
}
